import { Component, EventEmitter, Host, Prop, h, Event } from '@stencil/core';
export interface ProgressInfo {
  step: string;
  details: string;
  progress: 'Todo' | 'Current' | 'Done' | 'Cancelled' | 'Error';
}

@Component({
  tag: 'dynamic-order-progression-stepper',
  styleUrl: 'dynamic-order-progression-stepper.scss',
  shadow: true,
})
export class DynamicOrderProgressionStepper {
  @Event() downloadClicked: EventEmitter<void>;
  @Prop() label: string;
  @Prop() progressInfos: ProgressInfo[] = [];
  private isAllDone: boolean;
  private lastStepIndex: number;

  componentWillLoad() {
    this.isAllDone = this.progressInfos.every(info => info.progress === 'Done');
    this.lastStepIndex = this.progressInfos.length - 1;
  }

 handleClick = () => {
    this.downloadClicked.emit();
 }

  render() {
    return (
      <Host>
        <div class="label">
          <h4>{this.label}</h4>
        </div>
        <div class="steps">
          {this.progressInfos.map((progressInfo, index) => {
            if (this.isAllDone && index === this.lastStepIndex) {
              return(
              <order-progression-step
                progressInfo={progressInfo}
                isLast={index === this.lastStepIndex}
              >
                <span slot="button">
              <theme-button
                variation="filled"
                onClick={this.handleClick}
              >
                <span slot='icon' class='material-icons-outlined'>
                  download
                </span>
                <span>Herunterladen</span>
              </theme-button>
                </span>
              </order-progression-step>
              )
            } else {
              return(
              <order-progression-step
                progressInfo={progressInfo}
                isLast={index === this.lastStepIndex}
              >
              </order-progression-step>
              )
            }
          }
          )}
        </div>
      </Host>
    );
  }
}
